<template>
  <div>
    <draggable
      v-if="itemData.blocks.length > 0 && !loadingBlock"
      v-model="itemData.blocks"
      tag="div"
      class="row"
      @change="ChangeBlockOrder(itemData.blocks)"
      :options="{ handle: '.handle-block', class: 'row' }" 
    >
      <b-col
        :id="'Section-' + itemData.id + '-block-' + item.id"
        :key="'Section-' + itemData.id + '-block-' + index"
        :md="item.col"
        v-for="(item, index) in even(itemData.blocks)"
        class="mb-2"
      >
        <div class="border p-2">
          <div class="d-flex justify-content-between align-items-center">
            <feather-icon
              icon="MenuIcon"
              size="18"
              class="cursor-pointer handle-block mr-2"
            />
            <div>
              <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-success"
                class="btn-icon rounded-circle mr-1"
                @click="updateBlock(item)"
              >
                <feather-icon icon="EditIcon" />
              </b-button>
              <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-danger"
                class="btn-icon rounded-circle"
                @click="removeItem(item.id)"
              >
                <feather-icon icon="XIcon" />
              </b-button>
            </div>
          </div>
          <div class="mt-2 ql-editor">
            <h3 v-if="item.title">{{ item.title[currentLocale] }}</h3>
            <div
              class="mt-2"
              v-if="item.types == 'content'"
              v-html="item.content[currentLocale]"
            ></div>
            <div class="mt-2 text-center" v-else>
              <img :src="item.fullpath" style="width: 100%" />
            </div>
          </div>
        </div>
      </b-col>
    </draggable>
  </div>
</template>
<script>
import draggable from "vuedraggable";
import Ripple from "vue-ripple-directive";
import { ref, onUnmounted } from "@vue/composition-api";
import store from "@/store";

import { BRow, BCol, BSpinner, BButton, VBModal } from "bootstrap-vue";
import "quill/dist/quill.core.css";

export default {
  components: {
    draggable,
    BRow,
    BCol,
    BSpinner,
    BButton,
    VBModal,
  },
  props: {
    itemData: {
      type: Object,
      required: false,
    },
    itemKey: {
      type: Number,
      required: false,
    },
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  }, computed: {
       
       currentLocale() {
         return  this.$i18n.locale;
       },
   },
  setup(props, { emit }) {
    const BlocksRepeater = ref([]);
    const Data = ref({ blocks: [] });
    const loadingBlock = ref(false);
    // BlocksRepeater.value = props.itemData.block
    const ChangeBlockOrder = async (items) => {
      let params = {
        id: props.itemData.id,
        items: items,
      };//
      loadingBlock.value = true;
      let blockes = await store.dispatch("blog-block/UpdateOrder", params);
      // props.itemData.block = [];
      emit("refesh-block", items[0].content_id);
      // getBlocks();
      // emit('refesh-blocks',props.itemKey)

      // console.log("block", items[0].content_id)
      // await store.dispatch('',);
      //Data.value.block  = [];
      //Data.value.block = items;
      // console.log("ITEM ", props.itemData)
    };
    
    const updateBlock = async (item) => {
      // console.log("item", item);
      emit("update-block", item);
      //update-block
    };
    const getBlocks = async () => {
      let blockes = await store.dispatch(
        "blog-block/fetchData",
        props.itemData.id
      );
      console.log('final here', blockes)
      if (blockes.data.success) {
        props.itemData.block = blockes.data.data;
      }
      loadingBlock.value = false;
    };
    const deleteItem = async (id) => {
      loadingBlock.value = true;
      await store.dispatch("blog-block/deleteBlock", id);
      emit("refesh-block", props.itemData.id);
    };


    return {
      BlocksRepeater,
      Data,
      ChangeBlockOrder,
      loadingBlock,
      deleteItem,
      updateBlock,
    };
  },
  methods: {
    removeItem(id) {
      this.$bvModal
        .msgBoxConfirm(
          "Please confirm that you want to delete Portfolio ID." + id,
          {
            title: "Please Confirm",
            size: "sm",
            okVariant: "danger",
            okTitle: "Yes",
            cancelTitle: "No",
            cancelVariant: "outline-secondary",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value === true) {
            this.deleteItem(id);
          }

          //this.deleteData(id)
        });
    },
    even: function (arr) {
      // Set slice() to avoid to generate an infinite loop!
      return arr.slice().sort(function (a, b) {
        return a.ordering_count - b.ordering_count;
      });
    },
  },
};
</script>
